import { viewAchievementMutation, type GetAchievementResponseDto } from '@helios/frontend-api-v2-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getFriendlyError } from '../../utils/error';
import { QUERY_KEY_ACHIEVEMENTS } from './useAchievements';

interface UseViewAchievementProps {
  mutate: (params: { id: string }) => void;
  isLoading: boolean;
  error: string | null;
  data: GetAchievementResponseDto | undefined;
  isSuccess: boolean;
  reset: () => void;
}

export const useViewAchievement = (): UseViewAchievementProps => {
  const queryClient = useQueryClient();

  const { mutate, isPending, error, data, isSuccess, reset } = useMutation({
    ...viewAchievementMutation(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY_ACHIEVEMENTS() });
    },
  });

  return {
    mutate: ({ id }: { id: string }) => mutate({ path: { id } }),
    isLoading: isPending,
    error: getFriendlyError(error as AxiosError, 'view achievement') || null,
    data,
    isSuccess,
    reset,
  };
};
